import styled from 'styled-components'
import { ZingTheme } from '../../../../../../../shared/src/assets/theme/types'

export const FooterWrapper = styled.footer`
  width: 100%;
  height: 13rem;
  background-color: ${({ theme }) => (theme as ZingTheme).colors.grey600};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const FooterLogo = styled.img`
  width: 150px;
  height: 50px;
  object-fit: contain;
`

export const FooterLinksWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FooterHr = styled.hr`
  width: 100%;
  margin: 0.55rem 0;
  border-color: ${({ theme }) => `${(theme as ZingTheme).colors.white}33`};
`

export const FooterEmail = styled.p`
  font-size: 0.75rem;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
  margin-bottom: 0.5rem;
`

export const FooterCopyright = styled.p`
  font-size: 0.75rem;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => (theme as ZingTheme).colors.white};
`
